import React from "react";
import { FormattedMessage } from "react-intl";

const SaleDrawerLogsDetails = ({filteredLogs}) => {
  return (
    <div style={{
      marginTop: "40px",
      display: "flex",
      flexDirection: "column" }}
    >
      <span style={{marginLeft: "8px", fontSize: "16px", fontWeight: "bold", color: "#152935"}}>
        <FormattedMessage id="preCog.assetsTab.drawer.logs.saleTitle" />
      </span>
      {/* Will be added in the future
      <span className="precog-assets-drawer-logs-sub-title">
        <FormattedMessage id="preCog.assetsTab.drawer.logs.purchaseDocInfoTitle" />
      </span> */}
      <span className="precog-assets-drawer-logs-sub-title">
        <FormattedMessage id="preCog.assetsTab.drawer.logs.docOpsInfoTitle" />
      </span> 
      <div>
        <span className="precog-assets-drawer-logs-depreciation-info-title">
          <FormattedMessage id="preCog.assetsTab.drawer.logs.saleDate" />
        </span>
        <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.date === null ? "XXXXXXX" : moment(filteredLogs[0]?.date).format("DD/MM/YYYY")}</p>
      </div>
      <div>
        <span className="precog-assets-drawer-logs-depreciation-info-title">
          <FormattedMessage id="preCog.assetsTab.drawer.logs.saleLogAmount" />
        </span>
        <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.logAmount === null ? "XXXXXXX" : `${numeral(filteredLogs[0]?.logAmount).format("0,0.00")} €`}</p>
      </div>
      <div>
        <span className="precog-assets-drawer-logs-depreciation-info-title">
          <FormattedMessage id="preCog.assetsTab.drawer.logs.saleRate" />
        </span>
        <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.rate === null ? "0 %": `${filteredLogs[0]?.rate} %`}</p>
      </div>
      {filteredLogs[0]?.capital !== 0 && <div>
        <span className="precog-assets-drawer-logs-depreciation-info-title">
          {(filteredLogs[0]?.capital > 0 && filteredLogs[0]?.trackType === "STATUTORY") && <FormattedMessage id="preCog.assetsTab.drawer.logs.capitalGainStatutory" />}
          {(filteredLogs[0]?.capital < 0 && filteredLogs[0]?.trackType === "STATUTORY") && <FormattedMessage id="preCog.assetsTab.drawer.logs.capitalLossStatutory" />}
          {(filteredLogs[0]?.capital > 0 && filteredLogs[0]?.trackType === "TAX") && <FormattedMessage id="preCog.assetsTab.drawer.logs.capitalGainTax" />}
          {(filteredLogs[0]?.capital < 0 && filteredLogs[0]?.trackType === "TAX") && <FormattedMessage id="preCog.assetsTab.drawer.logs.capitalLossTax" />}
        </span>
        <p className="precog-assets-drawer-logs-info">{`${numeral(filteredLogs[0]?.capital).format("0,0.00")} €`}</p>
      </div>}
      <div>
        <span className="precog-assets-drawer-logs-depreciation-info-title">
          <FormattedMessage id="preCog.assetsTab.drawer.logs.saleCarryingValue" />
        </span>
        <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.carryingValue === null ? "XXXXXXX" : `${numeral(filteredLogs[0]?.carryingValue).format("0,0.00")} €`}</p>
      </div>
      {/* Plusvalenza da ripartire, Ammortamento vendita, Ammortamento indeducibile will be added in the future */} 
    </div>
  );
};

export default SaleDrawerLogsDetails;